import React, { useMemo, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import AdminMaster from '../../../Layout/admin/Master';
import { Toast, ToastContainer, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useFormik } from 'formik';
import { BiReset, BiSearch } from 'react-icons/bi';
import { getUserlist } from '../../../Redux/qms/action';
import moment from 'moment';
import { getAllClientDropdown } from '../../../Redux/client/action';
import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import Select, { components } from 'react-select';
import 'rsuite/dist/rsuite.min.css';
import { Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import DateRangePicker from 'rsuite/DateRangePicker';
import { HiChevronDown } from 'react-icons/hi';
import { TbGridDots } from 'react-icons/tb';
import { converToStrDateTimeForAPI } from '../Dashboard/functions';
import { Tooltip } from '@mui/material';
import { getPropagationRecordsListData } from '../../../Redux/recordPropagation/action';
import FacilityMultiSelectSelect from '../../CommonComponent/FacilityMultiSelectSelect';
import { setSeconds } from 'date-fns/esm';
import { endOfYear, setHours, setMinutes, startOfYear } from 'date-fns';
import TableHeadings from '../../common/TableHeadings';
import CreatePropagateRequestModal from './components/CreatePropagateRequestModal';
import PropagationLogsModal from './components/PropagationLogsModal';
import RecordDetailsModal from './components/RecordDetailsModal';
import RevertPropagationModal from './components/RevertPropagationModal';
import RetriggerPropagationModal from './components/RetriggerPropagationModal';

const TextField = styled.input`
height: 32px;
width: 200px;
&:hover {
cursor: pointer;
}
`;

const getListRows = (raw) => {
    if (Array.isArray(raw?.results?.data)) return raw.results.data;
    if (Array.isArray(raw?.results)) return raw.results;
    if (Array.isArray(raw?.data)) return raw.data;
    if (Array.isArray(raw)) return raw;
    return [];
};

const getListCount = (raw, rows) => raw?.count ?? raw?.results?.count ?? rows.length;

const getRowKey = (row) => row?.id ?? row?.pk ?? (row ? `${row.source_job_id}-${row.propagate_job_id}-${row.created_date}` : undefined);

const formatDateTime = (value) => value ? moment(value).format('MM/DD/YYYY hh:mm A') : '-';

const REVERTABLE_STATUSES = ['COMPLETED', 'FAILED', 'REVERT_FAILED'];
const RETRIGGERABLE_STATUSES = ['COMPLETED', 'FAILED', 'REVERT_FAILED', 'REVERTED'];

const defaultColumns = {
    s_no: true,
    client_name: true,
    facility_name: true,
    lockbox_name: true,
    source_lockbox_file_name: true,
    propagate_lockbox_file_name: true,
    source_job: true,
    target_job: true,
    status: true,
    source_claims: true,
    target_claims: true,
    requested_user: true,
    reverted_by: true,
    created_date: true,
    modified_date: true,
    action: true,
};

const PropagateRecords = () => {

    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(100);
    const [limit, setLimit] = useState(100);
    const [data, setData] = useState({});
    const [colorRow, setColorRow] = React.useState({});
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [selectValue, setSelectValue] = useState([]);
    const [pageno, setPageNo] = useState(1);
    const [userlist, setUserlist] = useState();
    const [clientList, setClientList] = useState();
    const [toaster, setToaster] = useState(null);

    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    });
    const [filterState, setFilterState] = useState({
        staff: [],
        client: [],
        facility: [],
        client_group: [],
    });
    const [facilities, setFacilities] = useState([]);
    const [selectedFacility, setSelectedFacility] = useState([]);
    const [showCreatePropagateModal, setShowCreatePropagateModal] = useState(false);
    const [logsModal, setLogsModal] = useState({ show: false, recordId: null });
    const [detailsModal, setDetailsModal] = useState({ show: false, row: null });
    const [revertModal, setRevertModal] = useState({ show: false, row: null });
    const [retriggerModal, setRetriggerModal] = useState({ show: false, row: null });

    useEffect(() => {
        getUserlist(1)((response) => {
            setUserlist(response?.data?.results);
        });

        getAllClientDropdown()((response) => {
            setClientList(response?.data);
        });

    }, []);

    const [state, setState] = useState(defaultColumns);

    const predefinedBottomRanges = [
        {
            label: 'Today',
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
            placement: 'left'
        },
        {
            label: 'Yesterday',
            value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
            placement: 'left'
        },
        {
            label: 'This week',
            value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 7 days',
            value: [subDays(new Date().setHours(0, 0, 0, 0), 6), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 30 days',
            value: [subDays(new Date().setHours(0, 0, 0, 0), 29), new Date()],
            placement: 'left'
        },
        {
            label: 'This month',
            value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date()],
            placement: 'left'
        },
        {
            label: 'Last month',
            value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date(), -1))],
            placement: 'left'
        },
        {
            label: 'This year',
            value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date()],
            placement: 'left'
        },
        {
            label: 'Last year',
            value: [setSeconds(setMinutes(setHours(startOfYear(new Date(new Date().getFullYear() - 1, 0, 1)), 0), 0), 0), setSeconds(setMinutes(setHours(endOfYear(new Date(new Date().getFullYear(), 0, 0)), 23), 59), 59)],
            placement: 'left'
        },
        {
            label: 'Last week',
            closeOverlay: false,
            value: value => {
                const [start = new Date().setHours(0, 0, 0, 0)] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
                ];
            },
            appearance: 'default'
        },
        {
            label: 'Next week',
            closeOverlay: false,
            value: value => {
                const [start = new Date()] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
                ];
            },
            appearance: 'default'
        }
    ];

    const handleOnMultySelectChange = async (selected, name) => {
        let selectedIds = [];
        selected.map((option) => {
            selectedIds.push(option.value);
        });

        queueformik.setValues({ ...queueformik.values, [name]: selectedIds });

        setFilterState({
            ...filterState,
            [name]: selected
        });
        name === 'facility' && setSelectedFacility(selected);
        if (name === 'client' && selected?.length === 0) {
            setSelectedFacility([]);
            queueformik.setFieldValue("facility", []);
            setFacilities([]);
        }
    };

    const columns = useMemo(
        () => [
            {
                id: 'id',
                name: 'S NO',
                selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                wrap: true,
                width: "70px",
                grow: 0,
                omit: !state?.s_no
            },
            {
                id: 'client',
                name: 'Client',
                selector: row => row?.client_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.client_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.client_name}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "160px",
                grow: 0.3,
                omit: !state?.client_name
            },
            {
                id: 'facility',
                name: 'Facility',
                selector: row => row?.facility_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.facility_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.facility_name}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "160px",
                grow: 0.3,
                omit: !state?.facility_name
            },
            {
                id: 'lockbox_name',
                name: 'Lockbox',
                selector: row => row?.lockbox_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.lockbox_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.lockbox_name}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "200px",
                grow: 0.3,
                omit: !state?.lockbox_name
            },
            {
                id: 'source_lockbox_file_name',
                name: 'Source Lockbox File',
                selector: row => row?.source_lockbox_file_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.source_lockbox_file_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.source_lockbox_file_name}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "180px",
                grow: 0.3,
                omit: !state?.source_lockbox_file_name
            },
            {
                id: 'propagate_lockbox_file_name',
                name: 'Target Lockbox File',
                selector: row => row?.propagate_lockbox_file_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.propagate_lockbox_file_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.propagate_lockbox_file_name}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "180px",
                grow: 0.3,
                omit: !state?.propagate_lockbox_file_name
            },
            {
                id: 'source_job',
                name: 'Source Job',
                selector: row => row?.source_job,
                cell: (row) =>
                    <div className='text-truncate' style={{ width: "140px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        {row?.source_job}
                    </div>,
                sortable: true,
                wrap: true,
                width: "140px",
                grow: 0.3,
                omit: !state?.source_job
            },
            {
                id: 'target_job',
                name: 'Target Job',
                selector: row => row?.propagate_job,
                cell: (row) =>
                    <div className='text-truncate' style={{ width: "140px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        {row?.propagate_job}
                    </div>,
                sortable: true,
                wrap: true,
                width: "140px",
                grow: 0.3,
                omit: !state?.target_job
            },
            {
                id: 'status',
                name: 'Status',
                selector: row => row?.status,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.status} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.status}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "120px",
                omit: !state?.status
            },
            {
                id: 'source_claims',
                name: 'Source Claims',
                selector: row => row?.source_job_claims_count,
                wrap: true,
                width: "110px",
                omit: !state?.source_claims
            },
            {
                id: 'target_claims',
                name: 'Target Claims',
                selector: row => row?.propagate_job_claims_count,
                wrap: true,
                width: "110px",
                omit: !state?.target_claims
            },
            {
                id: 'requested_user',
                name: 'Requested User',
                selector: row => row?.requested_user,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.requested_user} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.requested_user}
                            </span>
                        </Tooltip>
                    </div>,
                sortable: true,
                wrap: true,
                width: "140px",
                grow: 0.3,
                omit: !state?.requested_user
            },
            {
                id: 'reverted_by',
                name: 'Reverted By',
                selector: row => row?.reverted_by,
                cell: (row) =>
                    <div className='text-truncate' style={{ width: "130px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        {row?.reverted_by || '-'}
                    </div>,
                sortable: true,
                wrap: true,
                width: "130px",
                grow: 0.3,
                omit: !state?.reverted_by
            },
            {
                id: 'created_date',
                name: 'Created Date',
                selector: row => row?.created_date,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        {formatDateTime(row?.created_date)}
                    </div>,
                sortable: true,
                wrap: true,
                width: "160px",
                grow: 0.3,
                omit: !state?.created_date
            },
            {
                id: 'modified_date',
                name: 'Modified Date',
                selector: row => row?.modified_date,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        {formatDateTime(row?.modified_date)}
                    </div>,
                sortable: true,
                wrap: true,
                width: "160px",
                grow: 0.3,
                omit: !state?.modified_date
            },
            {
                id: 'action',
                name: 'Action',
                center: true,
                width: "190px",
                grow: 0,
                omit: !state?.action,
                cell: (row) => (
                    <div className="d-flex align-items-center justify-content-center gap-3">
                        <Tooltip disableInteractive title="View Logs" placement='top' arrow>
                            <button
                                type="button"
                                className="btn btn-sm border-0 p-0"
                                style={{ color: '#6ba2b6' }}
                                onClick={(e) => { e.stopPropagation(); handleViewLogs(row); }}
                            >
                                <i className="bi bi-file-text fs-6"></i>
                            </button>
                        </Tooltip>
                        <Tooltip disableInteractive title="View Details" placement='top' arrow>
                            <button
                                type="button"
                                className="btn btn-sm border-0 p-0"
                                style={{ color: '#6ba2b6' }}
                                onClick={(e) => { e.stopPropagation(); handleViewDetails(row); }}
                            >
                                <i className="bi bi-info-circle fs-6"></i>
                            </button>
                        </Tooltip>
                        {REVERTABLE_STATUSES.includes(row?.status) ? (
                            <Tooltip disableInteractive title="Revert Propagation" placement='top' arrow>
                                <button
                                    type="button"
                                    className="btn btn-sm border-0 p-0"
                                    style={{ color: '#dc3545' }}
                                    onClick={(e) => { e.stopPropagation(); handleRevert(row); }}
                                >
                                    <i className="bi bi-arrow-counterclockwise fs-6"></i>
                                </button>
                            </Tooltip>
                        ) : (
                            <span className="btn btn-sm border-0 p-0 invisible" aria-hidden="true">
                                <i className="bi bi-arrow-counterclockwise fs-6"></i>
                            </span>
                        )}
                        {RETRIGGERABLE_STATUSES.includes(row?.status) ? (
                            <Tooltip disableInteractive title="Retrigger Propagation" placement='top' arrow>
                                <button
                                    type="button"
                                    className="btn btn-sm border-0 p-0"
                                    style={{ color: '#6ba2b6' }}
                                    onClick={(e) => { e.stopPropagation(); handleRetrigger(row); }}
                                >
                                    <i className="bi bi-arrow-repeat fs-6"></i>
                                </button>
                            </Tooltip>
                        ) : (
                            <span className="btn btn-sm border-0 p-0 invisible" aria-hidden="true">
                                <i className="bi bi-arrow-repeat fs-6"></i>
                            </span>
                        )}
                    </div>
                ),
            },
        ],
        [pageno, loading, state],
    );

    const handleViewLogs = (row) => {
        setLogsModal({ show: true, recordId: getRowKey(row) });
    };

    const handleViewDetails = (row) => {
        setDetailsModal({ show: true, row });
    };

    const handleRevert = (row) => {
        setRevertModal({ show: true, row });
    };

    const handleRetrigger = (row) => {
        setRetriggerModal({ show: true, row });
    };

    const handleSort = (column, sortDirection) => {
        setSortColumn(column.id);
        setSortOrder(sortDirection);
        fetchQueueListing({ page: pageno, limit, sort_key: column.id, sort_order: sortDirection, ...searchedData });
    };

    const fetchQueueListing = async (props) => {
        const { page, deposit_date_range } = props;
        setLoading(true);
        getPropagationRecordsListData({
            ...props,
            created_date: converToStrDateTimeForAPI(deposit_date_range),
        })((response) => {
            if (response?.status) {
                const rows = getListRows(response.data);
                setData(response.data);
                setTotalRows(getListCount(response.data, rows));
                setPageNo(page);
            }
            setLoading(false);
        });
    };

    const handlePageChange = page => {
        setPageNo(page);
        fetchQueueListing({ page, limit, sort_order: sortOrder, sort_key: sortColumn, ...searchedData });
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchQueueListing({ page, limit: newPerPage, sort_order: sortOrder, sort_key: sortColumn, ...searchedData });
        setLimit(newPerPage);
        handleResetDataTable();
    };

    const [searchedData, setSearchedData] = useState({
        client: "",
        facility: "",
        status: "",
        source_job: "",
        propagate_job: "",
        requested_user: "",
        deposit_date_range: "",
        created_date: "",
    });
    const [reRenderDataTable, setRerenderDataTable] = useState(false);

    const handleResetDataTable = () => {
        setRerenderDataTable(true);
        setTimeout(() => {
            setRerenderDataTable(false);
        }, 200);
    };

    const queueformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            client: [],
            facility: [],
            deposit_date_range: [],
            created_date: "",
            status: [],
            source_job: '',
            propagate_job: '',
            requested_user: [],
        },
        onSubmit: (values) => {
            setSortColumn("");
            setSortOrder("");

            fetchQueueListing({ page: 1, limit, sort_order: sortOrder, sort_key: sortColumn, ...values });
            setSearchedData({
                client: values?.client ? values?.client : "",
                facility: values?.facility ? values?.facility : "",
                status: values?.status ? values?.status : "",
                source_job: values?.source_job ? values?.source_job : "",
                propagate_job: values?.propagate_job ? values?.propagate_job : "",
                requested_user: values?.requested_user ? values?.requested_user : "",
                deposit_date_range: values?.deposit_date_range ? values?.deposit_date_range : "",
                created_date: values?.created_date ? values?.created_date : "",
            });
            handleResetDataTable();
        },
    });

    const handleOnDateTimeChange = ({ name, value }) => {
        let created_date = "";
        if (value !== null) {
            const datefrom = moment(value['0']).format('MM/DD/YYYY');
            const dateto = moment(value['1']).format('MM/DD/YYYY');

            created_date = datefrom + " - " + dateto;
        }

        queueformik.setValues({ ...queueformik.values, created_date, deposit_date_range: value ?? "" });
    };

    var i = 0;

    const conditionalRowStyles = [
        {
            when: row => { i = i + 1; return i % 2 == 0 || getRowKey(colorRow) === getRowKey(row) ? true : false },
            style: (row, index) => ({
                backgroundColor: getRowKey(colorRow) === getRowKey(row) ? '#dbf4f5' : '#f2f2f2',
            }),
        },
    ];

    const handleRowClick = (row) => {
        setColorRow(row);
    };
    const handleRowCheckClick = (row) => {
        setColorRow(row);
    };

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props} >
                {
                    queueformik.values[state]?.length > 1 ? (
                        <TbGridDots style={{ fontSize: "1.5em" }} />
                    ) : (
                        <HiChevronDown style={{ fontSize: "1.5em" }} />
                    )}
            </components.DropdownIndicator>
        );
    };

    const [isFocusedClient, setIsFocusedClient] = useState(false);
    const [isFocusedStatus, setIsFocusedStatus] = useState(false);
    const [isFocusUser, setIsFocusUser] = useState(false);

    const statusList = [
        { label: 'PENDING', value: 'PENDING' },
        { label: 'IN QUEUE', value: 'IN_QUEUE' },
        { label: 'IN PROGRESS', value: 'IN_PROGRESS' },
        { label: 'COMPLETED', value: 'COMPLETED' },
        { label: 'REVERTED', value: 'REVERTED' },
        { label: 'FAILED', value: 'FAILED' },
    ];

    const resetData = () => {
        queueformik.setValues(queueformik?.initialValues);
        setSelectValue([]);
        setSelectedFacility([]);
        setFilterState({
            staff: [],
            client: [],
            facility: [],
            client_group: [],
        });
        setSearchedData({});
        setSortColumn("");
        setSortOrder("");
        fetchQueueListing({ page: 1, limit, sort_order: sortOrder, sort_key: sortColumn, ...queueformik?.initialValues });
        handleResetDataTable();
    };

    const formatOptionLabel = ({ value, label, is_logged_in }) => (
        <div className='d-flex flex-row justify-content-between align-items-center'>
            <div>{label}</div>
            {is_logged_in ?
                <div className='ms-2 dot' />
                :
                <div></div>
            }
        </div>
    );

    const handleUserSelectChange = (selected, field) => {
        const values = selected?.map(opt => opt.value) || [];
        queueformik.setFieldValue(field, values);
    };

    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />

            <main id="main" className="main" >

                <div style={{ width: "80%" }} className="pagetitle tab-fixed-header d-flex justify-content-between align-items-center" >
                    <h1 id='page-title' >Clone Job Records </h1>
                    <Button
                        className="btn btn-primary btnHover"
                        onClick={() => setShowCreatePropagateModal(true)}
                    >
                        <i className="bi bi-plus-lg me-1"></i>
                        Create Propagate Request
                    </Button>
                </div>

                < ToastContainer className="p-3" position={"top-end"} >
                    <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                        {
                            status: false,
                            message: "",
                            type: "",
                        }
                    )}
                        show={ToastMessage?.status} animation={true} delay={2000} autohide >
                        <Toast.Body><span className='text-white' > {ToastMessage?.message} </span></Toast.Body >
                    </Toast>
                </ToastContainer>

                < section className="section mt-5" >
                    <div className="row align-items-top py-2 gap-2 gap-md-5" >
                        <div className="col-lg-12" >
                            <div className="card mb-5 mb-xl-8" >
                                <Form onSubmit={queueformik.handleSubmit} onReset={resetData}>
                                    <div className='' >
                                        <div className="d-flex flex-row justify-content-start gap-2 align-items-center px-4 py-4 flex-wrap py-3" >

                                            <div className='jobmonitor-select' >
                                                <Select
                                                    isMulti
                                                    options={clientList}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="client" /> }}
                                                    className="select-search-client "
                                                    classNamePrefix="select"
                                                    placeholder="Select Client"
                                                    value={filterState?.client}
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="client"
                                                    onChange={(e) => handleOnMultySelectChange(e, 'client')}
                                                    defaultValue={queueformik?.values?.client}
                                                    onFocus={() => setIsFocusedClient(true)}
                                                    onBlur={() => setIsFocusedClient(false)}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),
                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedClient ? "auto" : "30px",
                                                        }),
                                                    }} />
                                            </div>
                                            < div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <FacilityMultiSelectSelect setFacilities={setFacilities} options={facilities} clients={queueformik?.values?.client} facility={selectedFacility} setSelectedFacility={setSelectedFacility} handleChange={handleOnMultySelectChange} formik={queueformik} />
                                            </div>
                                            < div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <TextField
                                                    id="search"
                                                    className="form-control form-control-solid  b-r-10"
                                                    name='source_job'
                                                    type="search"
                                                    style={{ width: "100%" }}
                                                    placeholder="Source Job "
                                                    aria-label="Search Input"
                                                    value={queueformik.values?.source_job}
                                                    onChange={queueformik.handleChange}
                                                />
                                            </div>
                                            < div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <TextField
                                                    id="search"
                                                    className="form-control form-control-solid  b-r-10"
                                                    name='propagate_job'
                                                    type="search"
                                                    style={{ width: "100%" }}
                                                    placeholder="Target Job "
                                                    aria-label="Search Input"
                                                    value={queueformik.values?.propagate_job}
                                                    onChange={queueformik.handleChange}
                                                />
                                            </div>

                                            < Tooltip disableInteractive title="Created Date" placement='top' arrow >
                                                <div className='' >
                                                    <Stack direction="column" spacing={8} alignItems="flex-start" >
                                                        <DateRangePicker
                                                            ranges={predefinedBottomRanges}
                                                            cleanable
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            appearance="default"
                                                            format={"MM/dd/yyyy HH:mm"}
                                                            placement='auto'
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                                                            name="deposit_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'deposit_date_range', value: e }) }}
                                                            value={queueformik?.values?.deposit_date_range} />
                                                    </Stack>
                                                </div>
                                            </Tooltip>
                                            < div className='jobmonitor-select' >
                                                <Select
                                                    isMulti
                                                    options={statusList}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="status" /> }}
                                                    className="select-search-client "
                                                    classNamePrefix="select"
                                                    placeholder="Status"
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="status"
                                                    onChange={(e) => {
                                                        queueformik.setValues({
                                                            ...queueformik.values,
                                                            status: e?.map(i => i.value)
                                                        });
                                                    }}
                                                    value={statusList.filter(i => queueformik?.values?.status.includes(i.value))}
                                                    onFocus={() => setIsFocusedStatus(true)}
                                                    onBlur={() => setIsFocusedStatus(false)}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),
                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedStatus ? "auto" : "30px",
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            < div className='jobmonitor-select' >
                                                <Select
                                                    isMulti
                                                    options={userlist}
                                                    formatOptionLabel={formatOptionLabel}
                                                    className="select-search"
                                                    classNamePrefix="select"
                                                    placeholder="Requested By"
                                                    name="requested_user"
                                                    value={userlist?.filter(opt => queueformik.values?.requested_user?.includes(opt?.value))}
                                                    onFocus={() => setIsFocusUser(true)}
                                                    onBlur={() => setIsFocusUser(false)}
                                                    isClearable
                                                    onChange={(e) => handleUserSelectChange(e, 'requested_user')}
                                                    defaultValue={queueformik?.values?.requested_user}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),
                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusUser ? "auto" : "30px",
                                                        }),
                                                    }}
                                                />
                                            </div>

                                            < div className='' style={{ width: '' }}>
                                                <div className='d-flex justify-content-start gap-2' >
                                                    <Tooltip disableInteractive title="Search" placement='top' arrow >
                                                        <Button className="btn btn-light btn-active-primary  " type="submit" >
                                                            <span className="svg-icon svg-icon-3" >
                                                                <BiSearch />
                                                            </span>
                                                        </Button>
                                                    </Tooltip>
                                                    < Tooltip disableInteractive title="Reset" placement='top' arrow >
                                                        <Button className="btn btn-light btn-active-primary " type='reset' >
                                                            <span className="svg-icon svg-icon-3" >
                                                                <BiReset />
                                                            </span>
                                                        </Button>
                                                    </Tooltip>

                                                    <TableHeadings
                                                        columnState={state}
                                                        setColumnState={setState}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                                < div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive" >
                                        <div className="dashboardtable" >
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    fixedHeader={true}
                                                    data={getListRows(data)}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    theme="solarized"
                                                    pointerOnHover
                                                    customStyles={queueDatatableCustomStyles}
                                                    responsive={true}
                                                    sortServer
                                                    onSort={handleSort}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <CreatePropagateRequestModal
                    show={showCreatePropagateModal}
                    onClose={() => setShowCreatePropagateModal(false)}
                    onSuccess={() => {
                        setToastMessage({
                            status: true,
                            message: 'Propagate request scheduled successfully',
                            type: 'success',
                        });
                        fetchQueueListing({ page: pageno, limit, sort_order: sortOrder, sort_key: sortColumn, ...searchedData });
                    }}
                />

                <PropagationLogsModal
                    show={logsModal.show}
                    recordId={logsModal.recordId}
                    onClose={() => setLogsModal({ show: false, recordId: null })}
                />

                <RecordDetailsModal
                    show={detailsModal.show}
                    row={detailsModal.row}
                    onClose={() => setDetailsModal({ show: false, row: null })}
                />

                <RevertPropagationModal
                    show={revertModal.show}
                    row={revertModal.row}
                    onClose={() => setRevertModal({ show: false, row: null })}
                    onSuccess={() => {
                        setToastMessage({
                            status: true,
                            message: 'Propagation revert initiated successfully',
                            type: 'success',
                        });
                        fetchQueueListing({ page: pageno, limit, sort_order: sortOrder, sort_key: sortColumn, ...searchedData });
                    }}
                />

                <RetriggerPropagationModal
                    show={retriggerModal.show}
                    row={retriggerModal.row}
                    onClose={() => setRetriggerModal({ show: false, row: null })}
                    onSuccess={() => {
                        setToastMessage({
                            status: true,
                            message: 'Propagation retrigger initiated successfully',
                            type: 'success',
                        });
                        fetchQueueListing({ page: pageno, limit, sort_order: sortOrder, sort_key: sortColumn, ...searchedData });
                    }}
                />
            </main>

        </React.Fragment>
    );
};

export default PropagateRecords;
